import React from 'react';
import type { ChatMessage } from '../context/chatTypes';
import type { PaymentRequestPayload } from '../types/paymentTypes';
import { ChainsObjectsArr } from '../../../chainsStaticObject/chainsStaticData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

interface RequestBubbleProps {
  message: ChatMessage;
  onPayRequest?: (payload: PaymentRequestPayload) => void;
}

const RequestBubble: React.FC<RequestBubbleProps> = ({ message, onPayRequest }) => {
  const content = message.content as PaymentRequestPayload;
  const chainObj = ChainsObjectsArr.find((c: any) => c.chain === content.chain);

  const timeStr = message.sentAt.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div className="chat-request">
      <div className="chat-request__header">
        Payment Request
      </div>
      <div className="chat-request__divider" />
      <div className="chat-request__amount">
        {content.amount} {content.tokenSymbol}
        <span className="chat-request__chain-label">
          {' '}on {chainObj?.title || content.chain}
        </span>
      </div>
      {content.note && (
        <div className="chat-request__note">"{content.note}"</div>
      )}
      {!message.isSentByMe && onPayRequest && (
        <button
          className="chat-btn chat-btn--primary chat-request__pay-btn"
          onClick={() => onPayRequest(content)}
        >
          Pay Now
        </button>
      )}
      {message.isSentByMe && (
        <div className="chat-request__requested-label">Requested</div>
      )}
      <div className="chat-request__footer">
        <span className="chat-message__time">
          {timeStr}
          {message.isSentByMe && <FontAwesomeIcon icon={faCheck} className="chat-message__sent-icon" />}
        </span>
      </div>
    </div>
  );
};

export default RequestBubble;
